import { render, staticRenderFns } from "./input-number.vue?vue&type=template&id=2ba5582a"
import script from "./input-number.vue?vue&type=script&lang=ts"
export * from "./input-number.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports